export default __webpack_public_path__ + "static/media/card.965f605b.svg";